import { ReactSketchCanvasRef } from "react-sketch-canvas";
import { Dispatch, RefObject, SetStateAction } from "react";

export type DrawingContextType = {
  canvasRef: RefObject<ReactSketchCanvasRef> | null;
  eraseMode: boolean;
  setEraseMode: Dispatch<SetStateAction<boolean>>;
  strokeWidth: number;
  setStrokeWidth: Dispatch<SetStateAction<number>>;
  eraserWidth: number;
  setEraserWidth:Dispatch<SetStateAction<number>>;
  strokeColor: string;
  setStrokeColor: Dispatch<SetStateAction<string>>;
  setOperation: Dispatch<SetStateAction<OperationType>>;
  setImageUrl: Dispatch<SetStateAction<string>>;
  imageUrl: string;
  setSearchParams:Dispatch<SetStateAction<SearchType>>;
  operation:OperationType;
  searchParams:SearchType
  imageDetails:ImageDetailsType | null,
  setImageDetails:Dispatch<SetStateAction<ImageDetailsType | null>>
};

export const initialStateData: DrawingContextType = {
  eraseMode: false,
  setEraseMode: () => {},
  strokeWidth: 10,
  setStrokeWidth: () => {},
  eraserWidth: 10,
  setEraserWidth: () => {},
  strokeColor: "#000000",
  setStrokeColor: () => {},
  canvasRef: null,
  setOperation: () => {},
  setImageUrl: () => {},
  imageUrl: "",
  setSearchParams:()=>{},
  operation:"cursor-crosshair",
  searchParams:{
    pageNumber: 0,
    pageSize: 5,
    sortField: "createdByDate",
    sortOrder: "desc",
    refetch: true,
  },
  imageDetails:null,
  setImageDetails:()=>{}
};

export type ActivityListParamsType = {
  encounterId?:number;
  clinicId: number;
  pageSize: number;
  pageNumber: number;
  sortOrder: "ASC" | "DESC" | "asc" | "desc";
  sortField: string;
};

export type ActivityPostType = {
  activityImageId: number | null;
  fullBodyFile: string;
  imgName: string;
  encounterId: number;
  createdById: number;
  clinicId: number;
};

export type ActivityPostParamsType = Omit<
  ActivityPostType,
  "createdById" | "clinicId"
>;

export type ActivityList = {
  id: number;
  encounterId: number;
  clinicId: number;
  createdById: number;
  createdByDate: string;
  fullBodyImage: string;
  firstName: string;
};

export type ViewFileParamsType = {
  id: number;
  bodyImg: string;
  clinicId: number;
};

export type ViewFileResultType = {
  file:string,
  content:string
}

export type SearchType = Omit<ActivityListParamsType, "clinicId"> & {
  refetch:boolean
}

export type OperationType = "cursor-crosshair" | "cursor-cell"

export type ImageDetailsType = {
  activityImageId:number,
  imgName:string
}